import React, { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/src/all";

const useCardAnimations = (
    root: React.MutableRefObject<null>,
    index: number
) => {
    const componentSelector = gsap.utils.selector(root);
    console.log("🚀 ~ root:", root);

    useEffect(() => {
        const scrollAnimation = gsap.fromTo(
            componentSelector("#watch-image"),
            { y: "20px", ease: "linear" },
            { y: "-20px" }
        );

        ScrollTrigger.create({
            animation: scrollAnimation,
            trigger: root.current,
            start: "top 90%",
            end: "top 30%",
            scrub: 0.2,
        });

        gsap.set(componentSelector("#watch-image"), {
            y: "20px",
        });

        const id = (root.current as HTMLElement | null)?.id;
        console.log("🚙 useCardAnimations", id);
        return () => {
            gsap.killTweensOf(root.current);
            scrollAnimation.kill();
            console.log("🚗 useCardAnimations killed", id);
        };
    }, []);
};

export default useCardAnimations;
